import type { Projectbetrokkene } from '@models/Projectbetrokkene'

import { apiClient } from '../../gateways/api'

export { deleteProjectbetrokkene }

const deleteProjectbetrokkene = async ({
  projectbetrokkene,
}: {
  projectbetrokkene: Projectbetrokkene
}): Promise<void> => {
  await apiClient({
    url: `/rest/projectbetrokkene/${projectbetrokkene._id}`,
    method: 'DELETE',
  })
}
